/** biome-ignore-all lint/suspicious/noExplicitAny:  lsp-ok*/
'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { ExperienceCard } from './ExperienceCard';
import { ExperienceCardLCP } from './ExperienceCardLCP';
import type { ExperienceCardShellProps } from './types';
export const ExperienceCardShell = t0 => {
  const $ = _c(7);
  const {
    experience,
    isLCP: t1,
    countdownTimer: t2
  } = t0;
  const isLCP = t1 === undefined ? false : t1;
  const countdownTimer = t2 === undefined ? false : t2;
  const [enhanced, setEnhanced] = useState(!isLCP);
  let t3;
  let t4;
  if ($[0] !== isLCP) {
    t3 = () => {
      if (!isLCP) {
        return;
      }
      let cancelled = false;
      const enhance = () => {
        if (!cancelled) {
          setEnhanced(true);
        }
      };
      if ("scheduler" in window && "postTask" in (window as any).scheduler) {
        (window as any).scheduler.postTask(enhance, {
          priority: "user-visible"
        });
      } else {
        const timeoutId = window.setTimeout(enhance, 300);
        return () => {
          cancelled = true;
          clearTimeout(timeoutId);
        };
      }
      return () => {
        cancelled = true;
      };
    };
    t4 = [isLCP];
    $[0] = isLCP;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t5;
  if ($[3] !== countdownTimer || $[4] !== enhanced || $[5] !== experience) {
    t5 = <div className="h-full">{enhanced ? <ExperienceCard {...experience} countdownTimer={countdownTimer} /> : <ExperienceCardLCP ee_name={experience.ee_name} ee_img={experience.ee_img} id={experience.id} auction={experience.auction} celebrity={experience.celebrity} />}</div>;
    $[3] = countdownTimer;
    $[4] = enhanced;
    $[5] = experience;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};